import React, { useState } from 'react'
import TCModal from './TCModal'
import styles from './steps.module.scss'

export default function Steps({ ambassadorData }) {
  const [openModalTC, setOpenModalTC] = useState(false)

  return (
    <div className={styles.main}>
      {ambassadorData?.verified && (
        <div className={styles.information}>
          <h1 className={styles.title}>Give $75, Get $75!</h1>
          <p className={styles.text}>
            For every friend you refer to Mawoo Pets, you’ll get a $75 Amazon
            gift card and they’ll get $75 off their puppy purchase!*
          </p>
        </div>
      )}
      <h2 className={styles.title}>Three easy steps</h2>
      <section className={styles.container}>
        <div className={styles.step}>
          <img src="/referral/steps/step-1.svg" alt="step one" />
          <p className={styles.text}>
            Unlock your unique referral code and share it with family and
            friends
          </p>
        </div>
        <div className={styles.step}>
          <img src="/referral/steps/step-2.svg" alt="step two" />
          <p className={styles.text}>
            Your friend gets $75 off their fist puppy purchase
          </p>
        </div>
        <div className={styles._step}>
          <img src="/referral/steps/step-3.svg" alt="step three" />
          <p className={styles.text}>
            You get $75 Amazon gift card for every friend that makes a puppy
            purchase
          </p>
        </div>
      </section>
      {ambassadorData?.verified && (
        <span className={styles.terms}>
          *{' '}
          <div onClick={() => setOpenModalTC(true)} className={styles.tc}>
            Terms and Conditions
          </div>{' '}
          apply.{' '}
        </span>
      )}
      {openModalTC && (
        <TCModal isOpen={openModalTC} close={() => setOpenModalTC(false)} />
      )}
    </div>
  )
}
